import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';

import { ILogTagProps, LogTagType } from './LogTag.types';

import './LogTag.styles.scss';

const { Text } = Typography;

const LogTag = ({ value, block, centralize = true, type, className = '', style, ...props }: ILogTagProps) => {
  const { t } = useTranslation();

  const width = block ? '100%' : 'fit-content';
  const margin = centralize ? '0 auto' : null;

  const logText = typeof value === 'string' ? t(value) : value;

  const typeClass = useMemo(() => {
    switch (type) {
      case LogTagType.NEW:
        return 'np-log-tag--new';

      case LogTagType.OLD:
        return 'np-log-tag--old';

      default:
        return '';
    }
  }, [type]);

  return (
    <div style={{ width, margin, ...style }} className={`np-log-tag ${typeClass} ${className}`} {...props}>
      <Text>{logText}</Text>
    </div>
  );
};

export default LogTag;
